// This icon file is generated automatically.
var ShieldOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M768 548.57V182.86H512v649.71q68-36 121.71-78.28Q768 649.14 768 548.57zm109.71-438.86v438.86q0 49.14-19.14 97.43t-47.43 85.71-67.43 72.86-72.28 58.86-69.14 44.28T551.14 936t-24.28 11.43q-6.86 3.43-14.86 3.43t-14.86-3.43q-9.14-4-24.28-11.43t-51.15-28.29-69.14-44.28-72.28-58.86-67.43-72.86T165.43 646t-19.14-97.43V109.71q0-14.85 10.85-25.71t25.72-10.86h658.28q14.86 0 25.72 10.86t10.85 25.71z" } }] }, "name": "shield", "theme": "outlined" };
export default ShieldOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/ShieldOutlined.js
// module id = 4094
// module chunks = 0